import React, {Component} from 'react';

class Services extends Component {

    render() {
        return ( 
            <section className="HomeServices section is-medium">
                <div className="HomeServicesBg">
                    <div className="Bg"></div>
                    <div className="Overlay Top"></div>
                    <div className="Overlay Bottom"></div>
                </div>
                <div className="container has-text-centered">
                    <h2 className="SectionTitle title has-text-primary is-size-2 is-size-4-mobile">บริการของเรา</h2>
                </div>
                <div className="container">
                    <div className="HomeServicesGrid columns">
                        <div className="column">
                            <div className="content has-text-centered">
                                <p><img src="/Images/drone.svg" alt="Ling Pilot" width="96" height="96" /></p>
                                <h5 className="title is-size-5">Map Production</h5>
                            </div>
                            <div className="content has-text-centered">
                                <p>
                                    <label>รับผลิตแผนที่ด้วยโดรน</label><br/>
                                    <label>ทำให้ได้ภาพใหม่สะดวกถึงมือคุณ</label>
                                </p>
                            </div>
                        </div>
                        <div className="column">
                            <div className="content has-text-centered">
                                <p><img src="/Images/host.svg" alt="Ling Hosting" width="96" height="96" /></p>
                                <h5 className="title is-size-5">Map Data Hosting</h5>
                            </div>
                            <div className="content has-text-centered">
                                <p>
                                    <label>รับโฮสข้อมูลแผนที่</label><br/>
                                    <label>สะดวกเข้าถึงได้ทุกแพลตฟอร์ม</label>
                                </p>
                            </div>
                        </div>
                        <div className="column">
                            <div className="content has-text-centered">
                                <p><img src="/Images/app.svg" alt="Ling Application" width="96" height="96" /></p>
                                <h5 className="title is-size-5">Mobile App</h5>
                            </div>
                            <div className="content has-text-centered">
                                <p>
                                    <label>แอพเพื่อการสร้างข้อมูลแผนที่</label><br/>
                                    <label>ใช้ง่าย แสดงเป็นหน่วยไทย ไร่ งาน วา</label>
                                </p>
                            </div>
                        </div>
                        <div className="column">
                            <div className="content has-text-centered">
                                <p><img src="/Images/web.png" alt="Ling Application" width="96" height="96" /></p>
                                <h5 className="title is-size-5">Web App</h5>
                            </div>
                            <div className="content has-text-centered">
                                <p>
                                    <label>เว็บเพื่อสร้างและจัดการ</label><br/>
                                    <label>ข้อมูลแผนที่ เข้าถึงได้ทุกที่ทุกเวลา</label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Services;


// WEBPACK FOOTER //
// ./src/PageHome/_Services.js